'use client'
import React, { ReactElement } from 'react'
import Navigation from '@/components/navigation/Navigation'
import HeaderCopyright from '@/components/headers/HeaderCopyright'
import NavigationTabs from '@/components/navigation/NavigationTabs'

const Market = (): ReactElement => {
    return (
        <React.Fragment>
            <HeaderCopyright />
            <div className="main-container" id="outer-container">
                <Navigation />
                <NavigationTabs />
            </div>
        </React.Fragment>
    )
}

export default Market
